import { Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";          // 👈 เพิ่มบรรทัดนี้
import "../../../shared/styles/BrowseCategory.css";

const items = [
  { id: 1, label: "เนติบัณฑิต", query: "เนติบัณฑิต" },
  { id: 2, label: "ทนายความ", query: "ทนายความ" },
  { id: 3, label: "ผู้พิพากษา", query: "ผู้พิพากษา" },
  { id: 4, label: "อัยการ", query: "อัยการ" },
];

export default function BrowseCategory() {
  return (
    <Row xs={2} lg={4} className="g-3">
      {items.map((it) => (
        <Col key={it.id}>
          <Card
            as={Link}
            to={`/search?q=${encodeURIComponent(it.query)}`} // 👈 ส่งค่า title ไปหน้า search
            className="h-100 shadow-sm border-0 btn-gradient text-white text-center browse-card"
          >
            <Card.Body className="py-4 fw-bold">
              {it.label}
            </Card.Body>
          </Card>
        </Col>
      ))}
    </Row>
  );
}